import React from "react";
import PropTypes from "prop-types";
import "../../VehiculeForm.css";
import { vehiculeDataPropType } from "../../../../types/vehiculeTypes";

const DisplayLocationVehiculeOccasion = ({ vehiculeData, readOnly }) => {
  return (
    <div className="form-section">
      <div className="section">
        <h3>VÉHICULE EN LOCATION</h3>
        <div className="radio-group">
          <label>LE VÉHICULE EST-IL PRIS EN LOCATION?</label>
          <div className="radio-group-child">
            <div>
              <input
                type="radio"
                name="loc_0"
                value="1"
                checked={vehiculeData.loc_0?.toString() === "1"}
                readOnly={readOnly}
              />
              <label>OUI</label>
            </div>
            <div>
              <input
                type="radio"
                name="loc_0"
                value="0"
                checked={vehiculeData.loc_0?.toString() === "0"}
                readOnly={readOnly}
              />
              <label>NON</label>
            </div>
          </div>
        </div>

        {vehiculeData.loc_0?.toString() === "1" && (
          <div className="radio-group">
            <label>TYPE DE LOCATION:</label>
            <div className="radio-group-child">
              <div>
                <input
                  type="radio"
                  name="loc_1"
                  value="0"
                  checked={vehiculeData.loc_1?.toString() === "0"}
                  readOnly={readOnly}
                />
                <label>COURTE DURÉE</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="loc_1"
                  value="1"
                  checked={vehiculeData.loc_1?.toString() === "1"}
                  readOnly={readOnly}
                />
                <label>LONGUE DURÉE</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="loc_1"
                  value="2"
                  checked={vehiculeData.loc_1?.toString() === "2"}
                  readOnly={readOnly}
                />
                <label>CRÉDIT-BAIL</label>
              </div>
            </div>
          </div>
        )}
      </div>

      {vehiculeData.loc_0?.toString() === "1" && (
        <div className="section">
          <h3>LE LOUEUR</h3>
          <div className="radio-group">
            <label>VOUS ÊTES:</label>
            <div className="radio-group-child">
              <div>
                <input
                  type="radio"
                  name="loc_17"
                  value="0"
                  checked={vehiculeData.loc_17?.toString() === "0"}
                  readOnly={readOnly}
                />
                <label>PERSONNE PHYSIQUE</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="loc_17"
                  value="1"
                  checked={vehiculeData.loc_17?.toString() === "1"}
                  readOnly={readOnly}
                />
                <label>PERSONNE MORALE</label>
              </div>
            </div>
          </div>

          {vehiculeData.loc_17?.toString() === "0" ? (
            <>
              <div className="radio-group">
                <label>SEXE:</label>
                <div className="radio-group-child">
                  <div>
                    <input
                      type="radio"
                      name="loc_18"
                      value="0"
                      checked={vehiculeData.loc_18?.toString() === "0"}
                      readOnly={readOnly}
                    />
                    <label>MASCULIN</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      name="loc_18"
                      value="1"
                      checked={vehiculeData.loc_18?.toString() === "1"}
                      readOnly={readOnly}
                    />
                    <label>FÉMININ</label>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>NOM ET PRÉNOM:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_19 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>

              <div className="form-group">
                <label>NOM D&apos;USAGE (FACULTATIF):</label>
                <input
                  type="text"
                  value={vehiculeData.loc_20 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>
            </>
          ) : (
            <>
              <div className="form-group">
                <label>RAISON SOCIALE:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_3 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>

              <div className="form-group">
                <label>N° SIRET:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_4 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>
            </>
          )}

          <div className="form-group">
            <label>ETAGE / ESCALIER / APPARTEMENT:</label>
            <input
              type="text"
              value={vehiculeData.loc_12_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>IMMEUBLE / RÉSIDENCE / BÂTIMENT:</label>
            <input
              type="text"
              value={vehiculeData.loc_13_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>N° DE LA VOIE:</label>
            <input
              type="text"
              value={vehiculeData.loc_14_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>EXTENSION (BIS, TER, ..):</label>
            <input
              type="text"
              value={vehiculeData.loc_15_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>TYPE DE VOIE (RUE, AVENUE, ..):</label>
            <input
              type="text"
              value={vehiculeData.loc_16_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>LIBELLÉ DE VOIE:</label>
            <input
              type="text"
              value={vehiculeData.loc_17_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>LIEU-DIT / BP / LOCALITÉ:</label>
            <input
              type="text"
              value={vehiculeData.loc_18_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>CODE POSTAL:</label>
            <input
              type="text"
              value={vehiculeData.loc_19_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>COMMUNE:</label>
            <input
              type="text"
              value={vehiculeData.loc_20_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>TÉLÉPHONE PORTABLE:</label>
            <input
              type="text"
              value={vehiculeData.loc_21_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>ADRESSE MAIL:</label>
            <input
              type="text"
              value={vehiculeData.loc_22_1 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>
        </div>
      )}

      {vehiculeData.loc_0?.toString() === "1" && (vehiculeData.loc_1?.toString() === "1" || vehiculeData.loc_1?.toString() === "2") && (
        <div className="section">
          <h3>LE LOCATAIRE</h3>
          <div className="radio-group">
            <label>VOUS ÊTES:</label>
            <div className="radio-group-child">
              <div>
                <input
                  type="radio"
                  name="loc_5"
                  value="0"
                  checked={vehiculeData.loc_5?.toString() === "0"}
                  readOnly={readOnly}
                />
                <label>PERSONNE PHYSIQUE</label>
              </div>
              <div>
                <input
                  type="radio"
                  name="loc_5"
                  value="1"
                  checked={vehiculeData.loc_5?.toString() === "1"}
                  readOnly={readOnly}
                />
                <label>PERSONNE MORALE</label>
              </div>
            </div>
          </div>

          {vehiculeData.loc_5?.toString() === "0" ? (
            <>
              <div className="form-group">
                <label>NOM ET PRÉNOM:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_23 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>

              <div className="form-group">
                <label>NOM D&apos;USAGE (FACULTATIF):</label>
                <input
                  type="text"
                  value={vehiculeData.loc_24 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>
            </>
          ) : (
            <>
              <div className="form-group">
                <label>RAISON SOCIALE:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_7 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>

              <div className="form-group">
                <label>N° SIRET:</label>
                <input
                  type="text"
                  value={vehiculeData.loc_8 || ""}
                  readOnly={readOnly}
                  className={readOnly ? "readonly" : ""}
                />
              </div>
            </>
          )}

          <div className="form-group">
            <label>ETAGE / ESCALIER / APPARTEMENT:</label>
            <input
              type="text"
              value={vehiculeData.loc_12_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>IMMEUBLE / RÉSIDENCE / BÂTIMENT:</label>
            <input
              type="text"
              value={vehiculeData.loc_13_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>N° DE LA VOIE:</label>
            <input
              type="text"
              value={vehiculeData.loc_14_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>EXTENSION (BIS, TER, ..):</label>
            <input
              type="text"
              value={vehiculeData.loc_15_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>TYPE DE VOIE (RUE, AVENUE, ..):</label>
            <input
              type="text"
              value={vehiculeData.loc_16_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>LIBELLÉ DE VOIE:</label>
            <input
              type="text"
              value={vehiculeData.loc_17_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>LIEU-DIT / BP / LOCALITÉ:</label>
            <input
              type="text"
              value={vehiculeData.loc_18_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>CODE POSTAL:</label>
            <input
              type="text"
              value={vehiculeData.loc_19_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>COMMUNE:</label>
            <input
              type="text"
              value={vehiculeData.loc_20_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>TÉLÉPHONE PORTABLE:</label>
            <input
              type="text"
              value={vehiculeData.loc_21_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>

          <div className="form-group">
            <label>ADRESSE MAIL:</label>
            <input
              type="text"
              value={vehiculeData.loc_22_2 || ""}
              readOnly={readOnly}
              className={readOnly ? "readonly" : ""}
            />
          </div>
        </div>
      )}
    </div>
  );
};

DisplayLocationVehiculeOccasion.propTypes = {
  vehiculeData: vehiculeDataPropType.isRequired,
  readOnly: PropTypes.bool
};

DisplayLocationVehiculeOccasion.defaultProps = {
  readOnly: false
};

export default DisplayLocationVehiculeOccasion; 